/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, time: NonNullable<unknown> }} Irrigation_Run_BookedInputs */

const vi_irrigation_run_booked = /** @type {(inputs: Irrigation_Run_BookedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã hẹn tưới ${i?.name} lúc ${i?.time}.`)
};

/**

* @param {Irrigation_Run_BookedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_booked = /** @type {((inputs: Irrigation_Run_BookedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_BookedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_booked(inputs)
});